import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-history-card',
  templateUrl: './history-card.component.html',
  styleUrls: ['./history-card.component.scss']
})
export class HistoryCardComponent {

  @Input() isMyClinic: boolean = false
  @Input() legacy: string | null = "xxxxxxxxx"
}
